import { shippingStatusQueryUrl } from "./endpoints.js";
const ShippingStatusQueryCacheKey = ({
  accountId,
  accountIdType,
  paymentInstrumentReferenceId
}) => [
  shippingStatusQueryUrl,
  { accountId, accountIdType, paymentInstrumentReferenceId }
];
export {
  ShippingStatusQueryCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
